import React, { ReactElement, useCallback, useMemo } from 'react';

import { Textarea } from 'src/ui/components';

import {
  CustomLookupRecord,
  LookupColumnResponse,
  ResponseType,
} from 'src/features/PersonRepository/types/QuestionsTabType';
import { disableQnText } from 'src/features/PersonRepository/utils/personRepoConstants';

export function LookupEdit({
  question,
}: {
  question: ResponseType;
}): ReactElement {
  const getResponseValues = useCallback(
    (record: any) => {
      let responseValues: Array<LookupColumnResponse> = [];
      const mappedLookupColumns = question.Options;

      if (record === null) return [];

      for (const [mappingIdx, mappedColumn] of Object.entries(
        mappedLookupColumns,
      )) {
        if (mappedColumn.SendToAccount) {
          responseValues.push({
            ColumnName: mappedColumn?.LookupColumnName,
            Response: record[mappedColumn?.LookupColumnName],
          });
        }
      }
      return responseValues;
    },
    [question],
  );

  const result = useMemo(() => {
    let result: Array<LookupColumnResponse> = [];

    if (question.Value !== null && question.Value !== '') {
      let lookupResponse: Array<CustomLookupRecord> = JSON.parse(
        question.Value,
      );

      // Mapping lookup columns and response values
      if (Array.isArray(lookupResponse)) {
        lookupResponse?.forEach(record => {
          let responseValues = getResponseValues(record);
          responseValues?.forEach((responseValue: any) => {
            result.push({
              ColumnName: responseValue.ColumnName,
              Response: responseValue.Response,
            });
          });

          if (record.EmailTo) {
            result.push({ ColumnName: 'Email to', Response: record.EmailTo });
          }
          result.push({ ColumnName: 'LineBreaker', Response: '' });
        });
      } else {
        let responseValues = getResponseValues(lookupResponse);
        responseValues?.forEach((responseValue: any) => {
          result.push({
            ColumnName: responseValue.ColumnName,
            Response: responseValue.Response,
          });
        });
        if (lookupResponse['EmailTo']) {
          result.push({
            ColumnName: 'Email to',
            Response: lookupResponse['EmailTo'],
          });
        }
        result.push({ ColumnName: 'LineBreaker', Response: '' });
      }
    }

    return result
      .filter(item => item.ColumnName !== 'LineBreaker')
      .map(({ ColumnName, Response }) => `${ColumnName}:${Response}`)
      .join('\n');
  }, [getResponseValues, question.Value]);

  console.log('result', result);

  return (
    <dd className="flex gap-2  border-b dark:border-dark-medium">
      <h4 className="w-1/3 px-3 py-2 text-sm font-medium">
        {question?.FieldLabel}
      </h4>
      <div className="w-4/6 px-3 py-2">
        <Textarea
          id="lookupTextarea"
          // label="Comments"
          value={result}
          disabled
          title={disableQnText}
        />
      </div>
    </dd>
  );
}
